/**
 * A flat record with every key renamed and every value left alone —
 * `transformKeys(row, snake)`.
 *
 * One level deep, and `rename` is not asked to be injective: two keys that map to the same
 * name leave the later one standing.
 */
export function transformKeys<T>(
  source: Record<string, T>,
  rename: (key: string) => string
): Record<string, T> {
  return Object.fromEntries(
    Object.entries(source).map(([key, value]) => [rename(key), value])
  )
}
